import { createContext, useContext } from 'react';
export const BrandsContext = createContext(null);
export const useBrandsContext = () => useContext(BrandsContext);
